

































































import { Component, Prop, Vue } from 'vue-property-decorator';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';

@Component({
  components: {
    Navbar,
    Footer,
  },
})
export default class Precio extends Vue {
  public data() {
    return {
      title: 'Precios accesibles para todos',
      subtitle: 'La sonrisa que siempre has querido no tiene que quedarse en tus sueños. Los alineadores invisibles Toothly son hasta 60% más baratos que otros tratamientos de ortodoncia convencional.',
      pricesTitle: '¿Qué incluye nuestro tratamiento con alineadores Toothly?',
      pricesText: [
          { title: 'Kit de impresiones', price: '$2,000', text: '¡Tómate tus impresiones desde la comodidad de tu casa! El costo del kit de impresiones y la evaluación serán cubiertos con un pago inicial de $2,000. En caso de que determinemos que Toothly no es para ti, te haremos un reembolso.', img: 'kit-1' },
          { title: 'Kit de alineadores', price: '$20,500 de contado o $24,500 MSI', text: 'Un ortodoncista certificado producirá tu tratamiento con alineadores invisibles Toothly, el cual será enviado hasta tu casa. Monitorearemos de forma remota tu progreso.', img: 'kit-2' },
          { title: 'Retenedores', price: '$2,500', text: 'Los retenedores invisibles Toothly protegerán tu nueva sonrisa y evitarán que tus dientes vuelvan a su posición inicial. Tu tratamiento incluye tu primer set de retenedores, y podrás renovarlo cada 6 meses por solo $2,500.', img: 'kit-3' },
      ],
    };
  }
}
